export default __webpack_public_path__ + "b5b321bf6d7158bfd79954f74b73a1e5.png";